export default __webpack_public_path__ + "static/media/sandero-colour-6.af720d56.jpg";